import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const PlayerSelect = ({ player, setPlayer, players }) => {
  const options = players.map(({ id, name }) => ({ id, name }));
  const value = options.find((o) => String(o.id) === String(player)) ?? null;

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(o) => o.name}
      value={value}
      onChange={(_, newValue) => setPlayer(newValue?.id ?? null)}
      isOptionEqualToValue={(o, v) => String(o.id) === String(v.id)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Player"
          variant="standard"
          data-testid="player-select"
        />
      )}
    />
  );
};

export default PlayerSelect;
